import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const Card = ({
  icon,
  title,
  subtitle,
  orientation = "vertical",
  className = "",
}) => {
  return (
    <div
      className={`bg-white text-black rounded-lg shadow-lg p-4 sm:p-6 z-10 text-sm sm:text-base ${className} ${
        orientation === "horizontal"
          ? "flex items-center space-x-3"
          : "flex flex-col items-center text-center space-y-2"
      }`}
    >
      {/* Icon Container */}
      <div className="bg-primary text-white p-2 sm:p-3 rounded-full flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12">
        <FontAwesomeIcon icon={icon} className="text-base sm:text-lg" />
      </div>

      {/* Text Content */}
      <div>
        <h4 className="text-xl sm:text-2xl font-medium">{title}</h4>
        <p className="text-sm sm:text-md">{subtitle}</p>
      </div>
    </div>
  );
};

export default Card;
